import { api } from './client'

export interface ProfileUpdatePayload {
  full_name?: string
  phone?: string
  address?: string
  employee_number?: string
  organization_id?: number | null
  job_title?: string
  /** IANA timezone (ex: 'America/Manaus'). '' limpa override. */
  timezone?: string
  // Endereço estruturado (D-UX3).
  cep?: string
  logradouro?: string
  numero?: string
  complemento?: string
  bairro?: string
  cidade?: string
  uf?: string
}

export interface ProfileUpdateResponse {
  email: string
  full_name: string
  phone?: string | null
  address?: string | null
  employee_number?: string | null
  organization_id?: number | null
  job_title?: string | null
  timezone?: string | null
}

export interface AvatarPresignResponse {
  presigned_put_url: string
  s3_key: string
}

export interface OrgLite {
  id: number
  name: string
  logo_url?: string | null
}

/**
 * O que falta para a pessoa usar o shell pessoal nos servidores
 * (`GET /v1/profile/acesso-servidores`, spec 2026-11-03 secao 3.3).
 *
 * `sem_grupo_de_login` e `null` quando o Kanidm nao respondeu: "nao sei" nao
 * pode virar "voce nao esta no grupo", senao uma queda do Kanidm avisaria todo
 * mundo. `tenants` vazio = a pessoa nao abre shell pessoal em lugar nenhum.
 */
export interface AcessoServidores {
  tenants: { id: number; nome: string }[]
  sem_senha_unix: boolean
  sem_grupo_de_login: boolean | null
  grupos_de_login: string[]
  /** ISO 8601; `null` quando o ConsoleAI nunca registrou a senha UNIX da pessoa. */
  senha_unix_definida_em: string | null
}

export interface SenhaUnixDefinida {
  status: 'unix_password_set'
  definida_em: string
}

export const profileApi = {
  update: async (payload: ProfileUpdatePayload) => {
    const res = await api.patch<ProfileUpdateResponse>('/v1/profile', payload)
    return res.data
  },

  changePassword: async (current_password: string, new_password: string) => {
    const res = await api.post<{ status: string }>('/v1/profile/change-password', {
      current_password,
      new_password,
    })
    return res.data
  },

  /** Só a credencial UNIX do Kanidm (a que o `sudo` pede); a senha do login não muda. */
  definirSenhaUnix: async (new_password: string) => {
    const res = await api.post<SenhaUnixDefinida>('/v1/profile/unix-password', { new_password })
    return res.data
  },

  acessoServidores: async () => {
    const res = await api.get<AcessoServidores>('/v1/profile/acesso-servidores')
    return res.data
  },

  avatarPresign: async (filename: string, mime_type: string, size_bytes: number) => {
    const res = await api.post<AvatarPresignResponse>('/v1/profile/avatar/presign', {
      filename, mime_type, size_bytes,
    })
    return res.data
  },

  avatarConfirm: async (s3_key: string) => {
    const res = await api.post<{ avatar_url: string | null }>('/v1/profile/avatar/confirm', { s3_key })
    return res.data
  },

  avatarRemove: async () => {
    const res = await api.delete<{ status: string }>('/v1/profile/avatar')
    return res.data
  },

  organizationsLite: async () => {
    const res = await api.get<{ items: OrgLite[] }>('/v1/organizations/lite')
    return res.data.items
  },
}
